import { useState, useRef } from "react";
import { Play, X } from "lucide-react";

interface ExplanationVideoProps {
  videoUrl: string;
  onClose: () => void;
}

const ExplanationVideo = ({ videoUrl, onClose }: ExplanationVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="relative w-full max-w-2xl mx-4">
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
        <div className="rounded-2xl overflow-hidden border-2 border-accent/40 shadow-[0_0_40px_hsl(var(--accent)/0.3)]">
          <video
            ref={videoRef}
            src={videoUrl}
            className="w-full aspect-video object-contain bg-muted/70"
            autoPlay
            controls
            playsInline
            onEnded={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ExplanationVideo;
